// store/StoreProductCard.jsx
// Product card for the store profile page.
// Navigates to /:storeSlug/:productSlug on click.
// Props: product, storeSlug

import React from "react";
import { Link } from "react-router-dom";
import { Package, Clock } from "lucide-react";
import { brand } from "../shared/brand";

export function StoreProductCard({ product, storeSlug }) {
  const { title, price, primary_image, badge, product_slug, sku, stock_total } = product;
  const to = `/${storeSlug}/${product_slug || sku}`;

  const showBadge  = badge && badge.type !== "manana";
  const badgeBg    = badge?.type === "hoy_provider" ? brand.accentGreen : brand.accentGold;
  const outOfStock = stock_total != null && stock_total <= 0;

  return (
    <Link
      to={to}
      className={`group flex flex-col rounded-2xl bg-white border border-slate-100 overflow-hidden shadow-sm transition-all duration-200 ${
        outOfStock ? "opacity-60" : "hover:shadow-md hover:-translate-y-0.5"
      }`}
    >
      {/* Image */}
      <div className="relative aspect-square bg-slate-100 overflow-hidden">
        {primary_image ? (
          <img
            src={primary_image}
            alt={title}
            className={`h-full w-full object-cover transition-transform duration-300 ${!outOfStock ? "group-hover:scale-105" : ""}`}
            loading="lazy"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center">
            <Package className="size-10 text-slate-300" />
          </div>
        )}

        {/* Delivery badge */}
        {showBadge && (
          <div
            className="absolute top-2 left-2 flex items-center gap-1 rounded-lg px-2 py-0.5 text-[10px] font-bold text-white shadow"
            style={{ background: badgeBg }}
          >
            <Clock className="size-2.5" />
            {badge.label}
          </div>
        )}

        {/* Out of stock overlay */}
        {outOfStock && (
          <div className="absolute inset-0 flex items-center justify-center bg-white/60">
            <span className="rounded-lg bg-slate-700/80 px-2.5 py-1 text-[11px] font-bold text-white">
              Sin stock
            </span>
          </div>
        )}
      </div>

      {/* Info */}
      <div className="p-2.5 flex flex-col gap-0.5">
        <p className="text-sm font-semibold text-slate-800 leading-tight line-clamp-2">{title}</p>
        <p className="text-sm font-extrabold mt-1" style={{ color: brand.primary }}>
          S/ {parseFloat(price).toFixed(2)}
        </p>
      </div>
    </Link>
  );
}